import type { ReactNode } from "react";

interface IInlineAssetDiscussionCommentErrorProps {
  children: ReactNode;
}

export default function InlineAssetDiscussionCommentError({ children }: IInlineAssetDiscussionCommentErrorProps) {
  return (
    <div className="inline-flex rounded-xl bg-red-100 px-3 py-2 text-red-700 dark:bg-red-600/10 dark:text-rose-300">
      <p className="m-0 inline-flex text-sm font-medium tracking-wider">{children}</p>
    </div>
  );
}
